import * as React from 'react';
import styled from 'styled-components';
import { Text, Spacer, Center } from '../parts';
import { Footer } from './parts/Footer';

export const About: React.FC = () => {
	return (
		<PageBody>
			<Container>
				<Spacer size={60} />
				<Text weight="black" size={50} center>
					About Live Rewards
				</Text>
				<Spacer size={40} />
				<ContentSection>
					<Text weight="semi-bold" size={24}>
						Our Mission
					</Text>
					<Spacer size={20} />
					<Text color="#3d3d3d" size={16}>
						Live Rewards is dedicated to providing exclusive discount memberships that help you save money wherever you shop. We partner with thousands of brands to bring you the
						best deals on everything from groceries to fashion.
					</Text>
				</ContentSection>

				<Spacer size={60} />

				<ContentSection>
					<Text weight="semi-bold" size={24}>
						Why Choose Live Rewards?
					</Text>
					<Spacer size={20} />
					<Text color="#3d3d3d" size={16}>
						• Exclusive discounts from thousands of brands
						<br />
						• Local deal alerts tailored to your area
						<br />
						• Available nationwide
						<br />
						• Easy-to-use mobile app
						<br />• 24/7 customer support
					</Text>
				</ContentSection>

				<Spacer size={60} />

				<ContentSection>
					<Text weight="semi-bold" size={24}>
						Our Story
					</Text>
					<Spacer size={20} />
					<Text color="#3d3d3d" size={16}>
						Founded with the mission to help consumers save money, Live Rewards has grown to become a trusted discount membership program. We believe everyone deserves access to
						great deals, and we're committed to making that happen.
					</Text>
				</ContentSection>

				<Spacer size={100} />
			</Container>
			<Footer />
		</PageBody>
	);
};

const PageBody = styled.div``;

const Container = styled.div`
	max-width: 1200px;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 0px 20px;

	@media only screen and (max-width: 1200px) {
		padding: 0px 20px;
	}
`;

const ContentSection = styled.div`
	max-width: 800px;
	width: 100%;
`;
